/** Bulk-edit update key for the self-service section-mapping bulk apply (FR4). */
export const SECTION_MAPPING_BULK_UPDATE_KEY = 'section-mapping-bulk';
